const L = "is-mobile-full-width";
export {
  L as MOBILE_FULL_WIDTH_CLASSNAME
};
